export type ParsedLatLng = {
  lat: number
  lng: number
}

function toNum(v: string): number | null {
  const n = Number(v)
  if (!Number.isFinite(n)) return null
  return n
}

function inRange(lat: number, lng: number): boolean {
  return lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180
}

export function parseLatLng(input: string): ParsedLatLng | null {
  const raw = String(input || '').trim()
  if (!raw) return null

  const direct = raw.match(/^\s*(-?\d{1,2}(?:\.\d+)?)\s*,\s*(-?\d{1,3}(?:\.\d+)?)\s*$/)
  if (direct) {
    const lat = toNum(direct[1])
    const lng = toNum(direct[2])
    if (lat == null || lng == null || !inRange(lat, lng)) return null
    return { lat, lng }
  }

  try {
    const u = new URL(raw)
    const at = u.href.match(/@(-?\d{1,2}(?:\.\d+)?),(-?\d{1,3}(?:\.\d+)?)/)
    if (at) {
      const lat = toNum(at[1])
      const lng = toNum(at[2])
      if (lat != null && lng != null && inRange(lat, lng)) return { lat, lng }
    }

    const q = u.searchParams.get('q')
    if (q) {
      const m = q.match(/(-?\d{1,2}(?:\.\d+)?)\s*,\s*(-?\d{1,3}(?:\.\d+)?)/)
      if (m) {
        const lat = toNum(m[1])
        const lng = toNum(m[2])
        if (lat != null && lng != null && inRange(lat, lng)) return { lat, lng }
      }
    }

    const ll = u.searchParams.get('ll')
    if (ll) {
      const m = ll.match(/(-?\d{1,2}(?:\.\d+)?)\s*,\s*(-?\d{1,3}(?:\.\d+)?)/)
      if (m) {
        const lat = toNum(m[1])
        const lng = toNum(m[2])
        if (lat != null && lng != null && inRange(lat, lng)) return { lat, lng }
      }
    }
  } catch {
    return null
  }

  return null
}

export function formatCoord(value: number | null | undefined, digits = 5): string {
  if (value == null || !Number.isFinite(value)) return ''
  return value.toFixed(digits)
}

